"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.findAll = findAll;
var _request = _interopRequireDefault(require("@/utils/request"));
function findAll(listQuery) {
  return (0, _request.default)({
    url: '/withdraw',
    method: 'get',
    params: listQuery
  });
}
function create(data) {
  return (0, _request.default)({
    url: '/withdraw',
    method: 'post',
    data: data
  });
}